var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cockpit-User-Navigation-open",
    transform: "translate(-1277.000000, -220.000000)",
    stroke: "#D78787",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sub-Navigation",
    transform: "translate(80.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(979.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-copy-3",
    transform: "translate(32.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(92.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-out",
    transform: "translate(95.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,14 L1.33333333,14 C0.596953667,14 0,13.3035541 0,12.4444444 L0,1.55555556 C0,0.696445945 0.596953667,0 1.33333333,0 L4,0",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8.5 11 12.5 7 8.5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,7 L4,7",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7084ffbf760b4ee00e3a4384316057a4.svg";
export { ForwardRef as ReactComponent };